/* Good Travel · Seguimiento de presupuestos a medias: guarda el avance y anima a terminarlo */
(function () {
'use strict';
var KEY = 'gt-pres-pendiente', CERRADO = 'gt-pres-aviso-cerrado', DIAS = 14;
var PRES = '/pages/presupuesto';
function get(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
function set(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
function ses(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function vigente(b) { return b && b.t && (Date.now() - b.t) < (b.d ? DIAS : 3) * 864e5; }
function titular(b) { return b && b.d ? 'Tu viaje a ' + esc(b.d) : 'Tu próximo viaje'; }
function enlace(b) { return b && b.u ? b.u : PRES + (b && b.d ? '?destino=' + encodeURIComponent(b.d) : ''); }
function pct(b) { var n = (b && b.n) || 3; return Math.max(15, Math.round((((b && b.p) || 1) - 1) / n * 100)); }
function quedan(p) { var n = Math.max(1, 3 - (p || 1) + 1); return n === 1 ? 'Te queda solo el último paso' : 'Te quedan ' + n + ' pasos'; }

var css = document.createElement('style');
css.textContent =
  '.gts{--n:#0D014B;--a:#F5B700;font-family:"Figtree","Helvetica Neue",sans-serif;color:#15172B;box-sizing:border-box}' +
  '.gts *{box-sizing:border-box}' +
  '.gts-card{position:fixed;z-index:2147482000;left:96px;bottom:24px;width:min(400px,calc(100vw - 32px));display:flex;gap:12px;align-items:flex-start;padding:16px 16px 16px 14px;border-radius:20px;background:#fff;box-shadow:0 24px 60px -24px rgba(13,1,75,.55);border:1px solid #E4E5EE;transform:translateY(20px);opacity:0;transition:transform .35s cubic-bezier(.2,.8,.2,1),opacity .35s ease}' +
  '.gts-card.is-on{transform:none;opacity:1}' +
  '.gts-ic{flex:none;width:44px;height:44px;border-radius:14px;background:var(--n);color:var(--a);display:flex;align-items:center;justify-content:center;font-size:22px}' +
  '.gts-tx{flex:1;min-width:0}' +
  '.gts-tx b{display:block;font-size:16px;line-height:1.25;color:var(--n)}' +
  '.gts-tx span{display:block;margin-top:3px;font-size:13px;color:#5A5E86;line-height:1.35}' +
  '.gts-bar{height:6px;border-radius:9px;background:#EEEDF6;margin:10px 0 12px;overflow:hidden}.gts-bar i{display:block;height:100%;border-radius:9px;background:var(--a)}' +
  '.gts-go{display:inline-flex;align-items:center;gap:8px;height:42px;padding:0 18px;border-radius:999px;background:var(--a);color:var(--n);font-weight:800;font-size:15px;text-decoration:none;border:0;cursor:pointer}' +
  '.gts-go:focus-visible,.gts-x:focus-visible,.gts-alt:focus-visible{outline:3px solid var(--n);outline-offset:2px}' +
  '.gts-x{flex:none;width:32px;height:32px;margin:-4px -4px 0 0;border-radius:50%;border:0;background:#F2F1F8;color:var(--n);font-size:20px;line-height:1;cursor:pointer}' +
  '.gts-ban{display:flex;flex-wrap:wrap;align-items:center;gap:12px 16px;margin:0 0 18px;padding:16px 18px;border-radius:18px;background:#FFFBEA;border:1.5px solid #F5D46B}' +
  '.gts-ban .gts-tx b{font-size:17px}' +
  '.gts-alt{background:none;border:0;color:var(--n);font-weight:700;font-size:14px;text-decoration:underline;text-underline-offset:3px;cursor:pointer;padding:6px}' +
  '.gts-modal{position:fixed;inset:0;z-index:2147483001;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(13,1,75,.55)}' +
  '.gts-box{position:relative;width:min(460px,100%);padding:28px 26px 22px;border-radius:24px;background:#fff;text-align:center;box-shadow:0 30px 80px -30px rgba(13,1,75,.6)}' +
  '.gts-box .gts-ic{margin:0 auto 12px;width:56px;height:56px;font-size:28px;border-radius:18px}' +
  '.gts-box h3{margin:0 0 8px;font-size:24px;line-height:1.15;color:var(--n)}' +
  '.gts-box p{margin:0 0 18px;font-size:15px;line-height:1.5;color:#3A3D5C}' +
  '.gts-box .gts-go{width:100%;justify-content:center;height:50px;font-size:16px}' +
  '.gts-box .gts-alt{display:inline-block;margin-top:10px}' +
  '.gts-box .gts-x{position:absolute;top:14px;right:14px;margin:0}' +
  '.gts-toast{position:fixed;z-index:2147482000;left:50%;bottom:24px;transform:translate(-50%,20px);opacity:0;padding:12px 18px;border-radius:999px;background:var(--n);color:#fff;font-weight:700;font-size:14px;box-shadow:0 18px 40px -18px rgba(13,1,75,.6);transition:transform .3s ease,opacity .3s ease;max-width:calc(100vw - 32px);text-align:center}' +
  '.gts-toast.is-on{transform:translate(-50%,0);opacity:1}' +
  '.gts-dudas{left:auto;right:24px;bottom:auto;top:calc(var(--gth-h,80px) + 16px)}' +
  '@media (max-width:749px){.gts-card{left:16px;right:16px;width:auto;bottom:auto;top:calc(var(--gth-h,72px) + 10px);transform:translateY(-16px)}.gts-toast{bottom:auto;top:calc(var(--gth-h,72px) + 12px)}}' +
  '@media (prefers-reduced-motion:reduce){.gts-card,.gts-toast{transition:none}}';
document.head.appendChild(css);

/* Cualquier botón o enlace con finalidad «presupuesto» empieza el seguimiento */
function destinoDe(a) {
  try { var q = new URL(a.href, location.href).searchParams.get('destino'); if (q) return q; } catch (e) {}
  var h = document.querySelector('.gd h1, h1.gt-display');
  return h ? h.textContent.trim() : '';
}
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href], button');
  if (!a || a.closest('.gts, #gtq')) return;
  var href = a.getAttribute('href') || '';
  var txt = (a.textContent || '') + ' ' + (a.getAttribute('aria-label') || '');
  if (!/\/pages\/presupuesto/.test(href) && !/presupuesto|solicitar/i.test(txt)) return;
  var prev = get(KEY), d = destinoDe(a) || '';
  if (vigente(prev) && prev.p > 1 && (!d || prev.d === d)) return;
  set(KEY, { d: d, p: 1, n: 3, t: Date.now() });
}, true);

/* Formulario de las ofertas (5 pasos): también se sigue */
var fo = document.getElementById('gt-form-oferta');
if (fo) {
  if (fo.querySelector('.gt-ok, [data-of-done]')) set(KEY, null);
  var ofT = document.querySelector('h1.gt-display'), ofN = fo.querySelectorAll('[data-step]').length || 5, ofTm;
  var ofGuardar = function () {
    var act = fo.querySelector('[data-step].is-active'), p = act ? +act.dataset.step : 1;
    set(KEY, { d: ofT ? ofT.textContent.trim() : '', p: p, n: ofN, u: location.pathname + '#gt-solicitar', t: Date.now() });
  };
  ['click', 'input', 'change'].forEach(function (ev) { fo.addEventListener(ev, function () { clearTimeout(ofTm); ofTm = setTimeout(ofGuardar, 300); }); });
  fo.addEventListener('submit', function (e) { if (!e.defaultPrevented) set(KEY, null); });
}

var root = document.getElementById('gtq');
var enPresupuesto = !!(root && (root.querySelector('form') || root.querySelector('[data-done]')));

/* ---------- Página de presupuesto ---------- */
if (enPresupuesto) {
  if (root.querySelector('[data-done]')) { set(KEY, null); return; }
  var form = root.querySelector('form');
  var destF = root.querySelector('[data-f="dest"]'), refF = root.querySelector('[data-f="ref"]');
  function paso() { var p = root.querySelector('[data-panel]:not([hidden])'); return p ? +p.dataset.panel : 1; }
  function guardar() {
    var d = destF && destF.value.trim(), old = get(KEY);
    if (!d && !vigente(old)) return;
    set(KEY, { d: d || (old && old.d) || '', p: paso(), n: 3, t: Date.now(), r: refF ? refF.value : '' });
  }
  var tm;
  function luego() { clearTimeout(tm); tm = setTimeout(guardar, 300); }
  root.addEventListener('click', luego);
  root.addEventListener('input', luego);
  root.addEventListener('change', luego);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(luego);
    Array.prototype.forEach.call(root.querySelectorAll('[data-panel]'), function (p) { mo.observe(p, { attributes: true, attributeFilter: ['hidden'] }); });
  }
  /* Enviado de verdad (ningún control lo frenó): ya no está pendiente */
  if (form) form.addEventListener('submit', function (e) { if (!e.defaultPrevented) set(KEY, null); });

  /* Al volver: «tu viaje a X te está esperando» */
  var b = get(KEY);
  var pre = new URLSearchParams(location.search).get('destino');
  if (vigente(b) && b.d && !b.u && !pre) {
    var panel1 = root.querySelector('[data-panel="1"]');
    if (panel1) {
      var ban = document.createElement('div');
      ban.className = 'gts gts-ban';
      ban.setAttribute('role', 'status');
      ban.innerHTML = '<div class="gts-ic" aria-hidden="true">✈</div><div class="gts-tx"><b>Tu viaje a ' + esc(b.d) + ' te está esperando</b><span>Lo dejaste en el paso ' + (b.p || 1) + ' de 3. ' + quedan(b.p) + ' para recibir tu presupuesto, gratis y sin compromiso.</span></div>' +
        '<a class="gts-go" href="' + PRES + '?destino=' + encodeURIComponent(b.d) + '">Continuar con ' + esc(b.d) + ' →</a><button type="button" class="gts-alt" data-gts-nuevo>Empezar de cero</button>';
      panel1.insertBefore(ban, panel1.firstChild);
      ban.querySelector('[data-gts-nuevo]').addEventListener('click', function () { set(KEY, null); ban.remove(); });
    }
  }

  /* Si va a irse con el presupuesto a medias (ordenador): un empujón amable, una vez por visita */
  var wa = root.dataset.wa || '', tocado = false;
  root.addEventListener('pointerdown', function () { tocado = true; }, { once: true });
  root.addEventListener('keydown', function () { tocado = true; }, { once: true });

  /* Si se queda pensando mucho rato: un recordatorio amable (una vez por visita) */
  var quieto;
  function despierta() {
    clearTimeout(quieto);
    quieto = setTimeout(function () {
      if (ses('gts-dudas') || document.hidden) return;
      ses('gts-dudas', '1');
      var d = destF && destF.value.trim(), p = paso();
      var t = document.createElement('div');
      t.className = 'gts gts-card gts-dudas';
      t.setAttribute('role', 'status');
      t.innerHTML = '<div class="gts-ic" aria-hidden="true">✈</div><div class="gts-tx"><b>¿Lo estás pensando?</b>' +
        '<span>' + quedan(p) + (d ? ' para tu viaje a ' + esc(d) : '') + '. Es gratis y sin compromiso: te enviamos el presupuesto y decides con calma.</span>' +
        '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:12px"><button type="button" class="gts-go" data-gts-ok>Seguir con mi presupuesto</button>' +
        (wa ? '<a class="gts-alt" href="https://wa.me/' + esc(wa) + '?text=' + encodeURIComponent('Hola, tengo dudas con mi presupuesto' + (d ? ' para ' + d : '') + '.') + '" target="_blank" rel="noopener">Preguntar por WhatsApp</a>' : '') +
        '</div></div><button type="button" class="gts-x" aria-label="Cerrar">×</button>';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-on'); });
      var fuera2 = function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 400); };
      t.querySelector('.gts-x').addEventListener('click', fuera2);
      t.querySelector('[data-gts-ok]').addEventListener('click', function () {
        fuera2();
        var f = root.querySelector('[data-panel]:not([hidden]) input:not([type=hidden]), [data-panel]:not([hidden]) button');
        if (f) f.focus();
      });
      setTimeout(fuera2, 15000);
    }, 45000);
  }
  ['pointerdown', 'keydown', 'input', 'scroll'].forEach(function (ev) { (ev === 'scroll' ? window : root).addEventListener(ev, despierta, { passive: true }); });
  despierta();

  document.addEventListener('mouseout', function (e) {
    if (e.relatedTarget || e.clientY > 0 || ses('gts-salida')) return;
    var d = destF && destF.value.trim(), p = paso();
    if (!tocado || !vigente(get(KEY))) return;
    ses('gts-salida', '1');
    var m = document.createElement('div');
    m.className = 'gts gts-modal';
    m.innerHTML = '<div class="gts-box" role="dialog" aria-modal="true" aria-labelledby="gts-t"><button type="button" class="gts-x" data-gts-cerrar aria-label="Cerrar">×</button>' +
      '<div class="gts-ic" aria-hidden="true">✈</div><h3 id="gts-t">¡' + titular({ d: d }) + ' está casi listo!</h3>' +
      '<p>' + quedan(p) + '. Es gratis y sin compromiso: nuestro equipo te prepara el presupuesto a tu medida y te lo enviamos por email.</p>' +
      '<button type="button" class="gts-go" data-gts-cerrar>Terminar mi presupuesto</button>' +
      (wa ? '<br><a class="gts-alt" href="https://wa.me/' + esc(wa) + '?text=' + encodeURIComponent('Hola, estaba pidiendo un presupuesto en la web' + (d ? ' para viajar a ' + d : '') + '. ¿Me ayudáis?') + '" target="_blank" rel="noopener">Prefiero terminarlo por WhatsApp</a>' : '') +
      '</div>';
    document.body.appendChild(m);
    var cerrar = function () { m.remove(); document.removeEventListener('keydown', tecla); };
    var tecla = function (ev) { if (ev.key === 'Escape') cerrar(); };
    document.addEventListener('keydown', tecla);
    m.addEventListener('click', function (ev) { if (ev.target === m || ev.target.closest('[data-gts-cerrar]')) cerrar(); });
    m.querySelector('.gts-go').focus();
  });

  /* Si se fue a otra pestaña y vuelve: «te falta muy poco» */
  var fuera = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { fuera = Date.now(); return; }
    if (!fuera || Date.now() - fuera < 20000) return;
    var d = destF && destF.value.trim(), p = paso();
    if (!d || p < 2) return;
    var t = document.createElement('div');
    t.className = 'gts gts-toast';
    t.setAttribute('role', 'status');
    t.textContent = '¡Hola de nuevo! ' + quedan(p) + ' para tu viaje a ' + d + ' ✈';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 400); }, 6000);
  });
  return;
}

/* ---------- Resto de la web: recordatorio del presupuesto a medias ---------- */
var p = get(KEY);
if (!vigente(p)) { if (p) set(KEY, null); return; }
if (p.u && p.u.split('#')[0] === location.pathname) return;
var c = get(CERRADO);
if (c && Date.now() - c < 864e5) return;
setTimeout(function () {
  var card = document.createElement('div');
  card.className = 'gts gts-card';
  card.setAttribute('role', 'status');
  card.innerHTML = '<div class="gts-ic" aria-hidden="true">✈</div><div class="gts-tx"><b>' + titular(p) + ' está a medio camino</b>' +
    '<span>Termínalo en un minuto y recibe tu presupuesto, gratis y sin compromiso.</span>' +
    '<div class="gts-bar" aria-hidden="true"><i style="width:' + pct(p) + '%"></i></div>' +
    '<a class="gts-go" href="' + esc(enlace(p)) + '">Terminar mi presupuesto →</a></div>' +
    '<button type="button" class="gts-x" aria-label="Cerrar aviso">×</button>';
  document.body.appendChild(card);
  requestAnimationFrame(function () { card.classList.add('is-on'); });
  card.querySelector('.gts-x').addEventListener('click', function () { set(CERRADO, Date.now()); card.classList.remove('is-on'); setTimeout(function () { card.remove(); }, 400); });
}, 3000);
})();
